import { useEffect, useState } from "react"
import { PPTRamsesDescription } from "../../helpers/interfaces"
import { FormEditMode } from "../../helpers/constants"
import { createPPTRameses, updatePPTRameses } from "../../apiServices/CTBMappingKeysApi"
import CustomDialog from "../CustomDialog"
import { CustomTextField } from "../../layouts/themes"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"

interface Props {

    setFormEditMode: React.Dispatch<React.SetStateAction<number>>
    pptRamsesEditMode: number
    setPPTRamses: React.Dispatch<React.SetStateAction<PPTRamsesDescription[]>>
    pptRamses: PPTRamsesDescription[]
    pptRamsesToEdit: string
    openPPTRamsesForm: boolean
    setOpenPPTRamsesForm: React.Dispatch<React.SetStateAction<boolean>>

}
function CreateEditPPTRamses(props: Props) {
    const [pptRamsesName, setPPTRamsesName] = useState<string>("");

    useEffect(() => {
        if (props.pptRamsesEditMode === FormEditMode.EDIT) {
            var ramsesName = props.pptRamses.find(e => e.id === props.pptRamsesToEdit)
            if (!ramsesName) return
            setPPTRamsesName(ramsesName.name)
           
        }
    }, [props.pptRamses, props.pptRamsesEditMode, props.pptRamsesToEdit])

    function createNewPPTRamses() {
        createPPTRameses(pptRamsesName).then(ramses=> {
            props.setOpenPPTRamsesForm(false);
            props.setPPTRamses(ram => [...ram, ramses])
            
        })
    }
    function updateNewPPTRamses() {
        updatePPTRameses(props.pptRamsesToEdit, pptRamsesName).then(result => {
            props.setOpenPPTRamsesForm(false);
            props.setPPTRamses(rec => rec.map(a=> a.id === props.pptRamsesToEdit ? result: a))
           
        })
    }
    return(
        <>
        <CustomDialog dialogTitle={props.pptRamsesEditMode === FormEditMode.CREATE ? 'Add PPT Ramses Description ' : 'Update PPT Ramses Description  '} setOpenDialog={props.setOpenPPTRamsesForm} openDialog={props.openPPTRamsesForm}>
            <form>
                <div >
                    <label className='title-label'>PPT Ramses Description  Name <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="PPT Ramses Description Name" value={pptRamsesName} onChange={(e) => setPPTRamsesName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
               

                <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                    <Button disabled={!pptRamsesName} variant="contained" color='secondary' onClick={props.pptRamsesEditMode === FormEditMode.CREATE ? createNewPPTRamses : updateNewPPTRamses} >
                        <Add />&nbsp; {props.pptRamsesEditMode === FormEditMode.CREATE ? 'Add  PPT Ramses Description ' : 'Update PPT Ramses Description'}
                    </Button>
                </div>
            </form >


        </CustomDialog>

    </>
    )
}
export default CreateEditPPTRamses